export const initState = () => ({
    type: null,
    title: null,
    dialog: false,
    id: null
})

export const state = initState()
